"use client";

import PageNotFoundImage from "../_icons/pageNotFound";
import { useTranslations } from "next-intl";
import { Action } from "@clover-web-lib-sprout/action";

export default function PageNotFound() {
  const t = useTranslations("PageNotFound");

  const handleClick = () => {
    window.location.href = `/`;
  };

  return (
    <div className="w-full flex flex-col items-center justify-center h-[60vh]">
      <PageNotFoundImage />
      <h2 className="text-[32px] leading-[40px] mt-[22px] mb-[22px]">
        {t("title")}
      </h2>
      <p className="mb-[35px]">{t("message")}</p>
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        <Action>{t("homepageButton")}</Action>
      </div>
    </div>
  );
}
